export const SECTOR_EXPERIENCE = [
  'Accommodation and Food Services',
  'Arts and Entertainment',
  'Agriculture, Forestry and Fishing',
  'Construction and Real Estate',
  'Professional Services',
  'IT and Telecom',
  'Mining and Quarrying',
  'Utilities',
  'Wholesale and Retail',
  'Medical and Healthcare',
  'Consumer Goods Manufacturing',
  'Industrial Manufacturing',
  'Specialised Manufacturing',
  'Other',
];

export const ACCREDITATIONS = [
  'None',
  'Amazon Inbound Preferred Carrier (IPCP)',
  'BRC',
  'CBP Supply Chain Security',
  'MHRA',
  'Organic Food Federation',
  'Organic Farmers and Growers',
  'SOIL',
  'UKWA',
  'Other',
];

export const TEMPERATURE_CONTROLS = [
  {
    label: 'Ambient',
    value: 'Ambient',
  },
  {
    label: 'Chilled',
    value: 'Chilled',
  },
  {
    label: 'Frozen',
    value: 'Frozen',
  },
  {
    label: 'Mixed',
    value: 'Mixed',
  },
];

export const TEMPERATURE_MONITORING = [
  'Temperature Monitoring',
  'Humidity Monitoring',
  'Total Control System',
  'N/A',
];

export const SYSTEMS = ['WMS', 'TMS', 'WiFi', 'API', 'EDI', 'Other'];

export const SAFETY_AND_SECURITY = [
  '24/7 Security',
  '24/7 Access',
  'Bunded',
  'Caged',
  'Sprinklered',
  'Alarmed',
  'Patrolled',
  'Fenced Yard',
  'CCTV',
  'ESFR Sprinkler System',
];

export const CAPACITY_UOM = [
  {
    label: 'Pallets',
    value: 'Pallets',
  },
  {
    label: 'Sq.ft',
    value: 'Square Foot',
  },
  {
    label: 'Sq.m',
    value: 'Square Metre',
  },
];

export const SERVICE_TIME_UNITS = [
  {
    label: 'Week(s)',
    value: 'Week',
  },
  {
    label: 'Month(s)',
    value: 'Month',
  },
  {
    label: 'Year(s)',
    value: 'Year',
  },
];

export const SPECIAL_FACILITIES = [
  {
    label: 'Bulk Powder',
    value: 'Bulk Powder',
  },
  {
    label: 'Bulk Liquid',
    value: 'Bulk Liquid',
  },
  {
    label: 'Hazardous Chemicals',
    value: 'Hazardous Chemicals',
  },
  {
    label: 'Hazardous Other',
    value: 'Hazardous Other',
  },
  {
    label: 'High Value',
    value: 'High Value',
  },
  {
    label: 'LME',
    value: 'LME',
  },
  {
    label: 'Wet Bonded',
    value: 'Wet Bonded',
  },
  {
    label: 'Dry Bonded',
    value: 'Dry Bonded',
  },
  {
    label: 'Container',
    value: 'Container',
  },
  {
    label: 'Outdoor',
    value: 'Outdoor',
  },
  {
    label: 'RF Technology',
    value: 'RF Technology',
  },
];

export const MATERIAL_HANDLING_EQUIPMENT = [
  {
    label: 'Counter Balance',
    value: 'Counter Balance',
  },
  {
    label: 'Crane',
    value: 'Crane',
  },
  {
    label: 'Reach Truck',
    value: 'Reach Truck',
  },
  {
    label: 'Trailer Parking',
    value: 'Trailer Parking',
  },
  {
    label: 'Fork Lift',
    value: 'Fork Lift',
  },
  {
    label: 'Pump Truck',
    value: 'Pump Truck',
  },
  {
    label: 'Container Ramps',
    value: 'Container Ramps',
  },
];

export const FACILITIES = [
  {
    label: 'Off dock',
    value: 'offDock',
  },
  {
    label: 'Quay',
    value: 'quay',
  },
];

export const ACCESS_SPACE_UOM = [
  {
    label: 'Feet (ft)',
    value: 'Foot',
  },
  {
    label: 'Metres (m)',
    value: 'Metre',
  },
];

export const SQUARE_ACCESS_SPACE_UOM = [
  {
    label: 'Square Feet (sq.ft)',
    value: 'Square Foot',
  },
  {
    label: 'Square Metres (sq.m)',
    value: 'Square Metre',
  },
];

export const CURRENCY = [
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'USD',
    value: 'USD',
  },
];

export const WAREHOUSE_OPERATIONS = [
  { label: 'Receipt and Putaway', value: 'Receipt and Putaway' },
  { label: 'Docking', value: 'Docking' },
  {
    label: 'Picking, Packing & Despatch',
    value: 'Picking, Packing & Despatch',
  },
  { label: 'Domestic Fulfilment', value: 'Domestic Fulfilment' },
  { label: 'International Fulfilment', value: 'International Fulfilment' },
  {
    label: 'Nationwide and International Distribution & Haulage',
    value: 'Nationwide and International Distribution & Haulage',
  },
  {
    label: 'Import/Export Documentation',
    value: 'Import/Export Documentation',
  },
  {
    label: 'Container Devanning and Sub-sorting',
    value: 'Container Devanning and Sub-sorting',
  },
  {
    label: 'Temporary Container Storage',
    value: 'Temporary Container Storage',
  },
  { label: 'Shrink Wrapping', value: 'Shrink Wrapping' },
  { label: 'Waste Disposal', value: 'Waste Disposal' },
  {
    label: 'Flexible Operations Schedule',
    value: 'Flexible Operations Schedule',
  },
];

export const FULFILMENT_SERVICES = [
  { label: '3rd Party Couriers', value: '3rd Party Couriers' },
  { label: 'Trans Loading', value: 'Trans Loading' },
  { label: 'Cross Docking', value: 'Cross Docking' },
  { label: 'Merge In Transit', value: 'Merge In Transit' },
  { label: 'Returns Logistics', value: 'Returns Logistics' },
  {
    label: 'Critical Inventory Logistics',
    value: 'Critical Inventory Logistics',
  },
];

export const ADDITIONAL_SERVICES = [
  {
    label: 'Re-packaging, Customised Labelling, Light Assembly & Documentation',
    value: 'Re-packaging, Customised Labelling, Light Assembly & Documentation',
  },
  {
    label: 'Re-processing and Quality Control Programs',
    value: 'Re-processing and Quality Control Programs',
  },
  {
    label: 'Return processing and Management',
    value: 'Return processing and Management',
  },
  { label: 'Contract Packing', value: 'Contract Packing' },
  {
    label: 'Procurement and Management of All Packaging Materials',
    value: 'Procurement and Management of All Packaging Materials',
  },
  {
    label: 'Product Kitting and Repackaging',
    value: 'Product Kitting and Repackaging',
  },
  { label: 'Contract Manufacturing', value: 'Contract Manufacturing' },
  { label: 'Hazardous Goods handling', value: 'Hazardous Goods handling' },
  { label: 'Special Projects', value: 'Special Projects' },
];

export const STANDARD_BUSINESS_HOURS = [
  {
    label: 'Standard 24/7',
    value: 'Standard24/7',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

export const DAYS = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
];

export const WORKING_FIELD_NAMES = [
  'mondayWorkingHours.working',
  'tuesdayWorkingHours.working',
  'wednesdayWorkingHours.working',
  'thursdayWorkingHours.working',
  'fridayWorkingHours.working',
  'saturdayWorkingHours.working',
  'sundayWorkingHours.working',
  'mondayLoadingHours.operating',
  'tuesdayLoadingHours.operating',
  'wednesdayLoadingHours.operating',
  'thursdayLoadingHours.operating',
  'fridayLoadingHours.operating',
  'saturdayLoadingHours.operating',
  'sundayLoadingHours.operating',
] as const;

export const OPENING_TIME_FIELD_NAMES = [
  'mondayWorkingHours.openingTime',
  'tuesdayWorkingHours.openingTime',
  'wednesdayWorkingHours.openingTime',
  'thursdayWorkingHours.openingTime',
  'fridayWorkingHours.openingTime',
  'saturdayWorkingHours.openingTime',
  'sundayWorkingHours.openingTime',
  'mondayLoadingHours.openingTime',
  'tuesdayLoadingHours.openingTime',
  'wednesdayLoadingHours.openingTime',
  'thursdayLoadingHours.openingTime',
  'fridayLoadingHours.openingTime',
  'saturdayLoadingHours.openingTime',
  'sundayLoadingHours.openingTime',
] as const;

export const CLOSING_TIME_FIELD_NAMES = [
  'mondayWorkingHours.closingTime',
  'tuesdayWorkingHours.closingTime',
  'wednesdayWorkingHours.closingTime',
  'thursdayWorkingHours.closingTime',
  'fridayWorkingHours.closingTime',
  'saturdayWorkingHours.closingTime',
  'sundayWorkingHours.closingTime',
  'mondayLoadingHours.closingTime',
  'tuesdayLoadingHours.closingTime',
  'wednesdayLoadingHours.closingTime',
  'thursdayLoadingHours.closingTime',
  'fridayLoadingHours.closingTime',
  'saturdayLoadingHours.closingTime',
  'sundayLoadingHours.closingTime',
] as const;
